/*
 *  Copyright IBM Corp. 2025
 *
 *  This source code is licensed under the Apache-2.0 license found in the
 *  LICENSE file in the root directory of this source tree.
 *
 *  @license
 */

import { createComponent } from "@lit/react";
import React from "react";

import CDSAIChatStopStreamingButtonElement from "../../../web-components/components/stopStreamingButton/cds-custom-aichat-stop-streaming-button";

const StopStreamingButton = createComponent({
  tagName: "cds-custom-aichat-stop-streaming-button",
  elementClass: CDSAIChatStopStreamingButtonElement,
  react: React,
});

export { StopStreamingButton };
